<inventory-summary [summaryList]="completeSummaryList"></inventory-summary>
